import { useEffect, useState, RefObject } from 'react';

/**
 * Hook to detect if an element's text content is truncated (overflowing)
 * @param elementRef - Ref to the element to check for truncation
 * @param dependencies - Optional dependencies array to re-check truncation when they change
 * @returns boolean indicating if the element is truncated
 */
export function useIsTruncated<T extends HTMLElement = HTMLElement>(
  elementRef: RefObject<T | null>,
  dependencies: unknown[] = []
): boolean {
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (elementRef.current) {
      const element = elementRef.current;
      setIsTruncated(element.scrollWidth > element.clientWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef, ...dependencies]);

  return isTruncated;
}
